module.exports = __webpack_public_path__ + "static/media/52611650_2452978408110669_175271542266003456_o.cf62eebe.jpg";